var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./CourierRate.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-542d91ee!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./CourierRate.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/RateAndBugs/CourierRate.vue
// module id = 408
// module chunks = 1